<template>
    <ProgressSpinner :pt="options" :style="styling" aria-label="Custom ProgressSpinner"/>
</template>

<script lang="ts" setup>
import ProgressSpinner from 'primevue/progressspinner';

const props = defineProps<{ styling: string, }>()

const options = {
    spinner: {style: {animationDuration: '0.7s'}},
    circle: {style: {stroke: '#F59E0B', strokeWidth: 3, animation: 'none'}}
};

</script>
